import { useState } from "react";
import { Clock, ChevronDown, ChevronUp } from "lucide-react";
import { useTranslate } from "ra-core";
import { useIsMobile } from "@/hooks/use-mobile";
import { Button } from "@/components/ui/button";

import { ActivityLog } from "../activity/ActivityLog";
import { ScrollableCard } from "./ScrollableCard";

export function DashboardActivityLog({
  collapsible = false,
}: {
  collapsible?: boolean;
}) {
  const isMobile = useIsMobile();
  const translate = useTranslate();
  const [expanded, setExpanded] = useState(true);

  const showChevron = collapsible && isMobile;

  return (
    <div className="flex flex-col md:h-full">
      <div className="flex items-center gap-2 mb-3 min-h-6 flex-none">
        <Clock className="text-nd-text-disabled w-4 h-4" strokeWidth={1.5} />
        <span className="font-nd-mono text-[11px] tracking-[0.08em] uppercase text-nd-text-secondary flex-1">
          {translate("crm.dashboard.latest_activity", {
            _: "Latest Activity",
          })}
        </span>
        {showChevron && (
          <Button
            variant="ghost"
            size="icon"
            className="h-6 w-6 p-0 text-nd-text-disabled hover:text-nd-text-secondary"
            onClick={() => setExpanded((v) => !v)}
          >
            {expanded ? (
              <ChevronUp className="w-3.5 h-3.5" strokeWidth={1.5} />
            ) : (
              <ChevronDown className="w-3.5 h-3.5" strokeWidth={1.5} />
            )}
          </Button>
        )}
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateRows: !collapsible || expanded ? "1fr" : "0fr",
          transition: collapsible
            ? "grid-template-rows 0.3s ease-out"
            : undefined,
          overflow: "hidden",
        }}
      >
        <div style={{ minHeight: 0, overflow: "hidden" }}>
          {isMobile ? (
            <ActivityLog pageSize={8} />
          ) : (
            <ScrollableCard className="p-6">
              <ActivityLog pageSize={10} />
            </ScrollableCard>
          )}
        </div>
      </div>
    </div>
  );
}
